import { ButtonHTMLAttributes, forwardRef } from "react";
import { ButtonTone } from "../Button/Button.style";
import { Wrapper } from "./IconButton.styles";

export interface IconButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> {
  // An icon says nothing to a screen reader, so the name is required.
  "aria-label": string;
  // 28px instead of 36px: inside an input, a table row or a drawer heading.
  compact?: boolean;
  tone?: ButtonTone;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ compact = false, tone = "muted", type = "button", ...rest }, ref) => (
    <Wrapper ref={ref} type={type} $compact={compact} $tone={tone} {...rest} />
  ),
);

IconButton.displayName = "IconButton";

export default IconButton;
